import ko from "knockout";
import _ from "underscore";
import GraphVariable from "ViewModels/graphVariable";
import GraphFeature from "ViewModels/graphFeature";

var GraphVariableGroup = function (parent, id, name, variables, selectedVariables, features, selectedFeatures, variableSelectionUpdateTrigger) {
  var self = this;

  var maxVariables = {
    distinct: 20,
    group: 5,
  };

  self.name = name;
  self.graphVariables = ko.observableArray([]);
  self.graphFeatures = ko.observableArray([]);

  _.each(variables, function (variable) {
    var isSelected = false;
    var variableId = variable.id ? variable.id : variable.id;
    var variableName = variable.name ? variable.name : variable.description;

    if (_.contains(selectedVariables, variableId.toString())) {
      isSelected = true;
    }

    self.graphVariables.push(new GraphVariable(variableName, variableId, isSelected, selectedVariables, variableSelectionUpdateTrigger, variable.onboardSystem, variable.displayName));
  });

  _.each(features, function (feature) {
    var isSelected = false;
    var featureId = feature.id;
    var featureName = feature.name;

    if (_.contains(selectedFeatures, featureId.toString())) {
      isSelected = true;
    }

    self.graphFeatures.push(new GraphFeature(featureName, featureId, isSelected, selectedFeatures, variableSelectionUpdateTrigger));
  });

  self.graphVariables(_.sortBy(self.graphVariables(), function (variable) { return variable.name; }));
  self.graphFeatures(_.sortBy(self.graphFeatures(), function (feature) { return feature.name; }));

  self.selectedGraphVariables = ko.pureComputed(function () {
    var selectedGraphVariables = _.filter(self.graphVariables(), function (variable) {
      return variable.isSelected();
    });
    return _.sortBy(selectedGraphVariables, "queue");
  });

  self.unselectedGraphVariables = ko.pureComputed(function () {
    return _.filter(self.graphVariables(), function (variable) {
      return !variable.isSelected();
    });
  });

  self.selectedGraphFeatures = ko.pureComputed(function () {
    var selectedGraphFeatures = _.filter(self.graphFeatures(), function (feature) {
      return feature.isSelected();
    });
    return _.sortBy(selectedGraphFeatures, "queue");
  });

  self.unselectedGraphFeatures = ko.pureComputed(function () {
    return _.filter(self.graphFeatures(), function (feature) {
      return !feature.isSelected();
    });
  });

  self.selectedIds = ko.pureComputed(function () {
    var selection = "";
    _.each(self.selectedGraphVariables(), function (item, index) {
      selection += item.id.toString();
      var seperator = id === 0 ? ";" : ",";
      if (index < self.selectedGraphVariables().length - 1) {
        selection += seperator;
      }
    });
    return selection;
  });

  self.selectedFeatureIds = ko.pureComputed(function () {
    var selection = "";
    _.each(self.selectedGraphFeatures(), function (item, index) {
      selection += item.id.toString();
      var seperator = id === 0 ? ";" : ",";
      if (index < self.selectedGraphFeatures().length - 1) {
        selection += seperator;
      }
    });
    return selection;
  });

  self.count = ko.pureComputed(function () {
    return self.selectedGraphVariables().length + self.selectedGraphFeatures().length;
  });

  self.maxVariables = ko.pureComputed(function () {
    var index = parent.currentGroupIndex();
    return index === 0 ? maxVariables.distinct : maxVariables.group;
  });

  self.clear = function () {
    _.each(self.graphVariables(), function (variable) {
      variable.unselect();
    });
    _.each(self.graphFeatures(), function (variable) {
      variable.unselect();
    });
  };
};

export default GraphVariableGroup;
